import React from "react";

function About() {
  return (
    <div className="AboutPage">
  <div>
    <h1>
        Welkom mijn naam is Sarah Eitjes. Ik heb mijn eerste React app gemaakt.
        Ik volg momenteel een opleiding bij winc academy.
        Het is een zware opleiding, maar wel leerzaam.</h1>
      </div>
    </div>
  );
}

export default About;